import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { isRequired } from './required.helper';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[optional]',
    standalone: false
})
export class OptionalDirective implements AfterViewInit {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('optional') private formControl: AbstractControl;
    private elem: HTMLElement;

    constructor(private _elementRef: ElementRef, private translate: TranslateService) {
        this.elem = _elementRef.nativeElement;
    }

    public ngAfterViewInit(): void {
        if (!isRequired(this.formControl)) {
            this.translate.get('optioneel').pipe(first()).subscribe(value => {
                this.elem.innerHTML += `<span class="label-optional"> (${value})</span>`;
            });
        }
    }
}
